<template>
    <el-table class="table-box" ref="elTable" :data="newRows" border style="width: 100%" tooltip-effect="dark"
        :row-class-name="rowClassHandler" v-bind="attrsExt" v-on="$listeners">
        <el-table-column v-if="selection" type="selection" fixed="left" width="40" align="center"
            :selectable="selectable"></el-table-column>
        <el-table-column v-if="index" type="index" :index="1" width="40" label="序号"></el-table-column>
        <!-- <template v-for="(col, cIndex) in activeColumns"> -->
        <el-table-column v-for="(col, cIndex) in activeColumns" :key="col.prop + cIndex + version" :label="$translate(col.label)"
            :show-overflow-tooltip="_.get(col, 'showTooltip', true)" :sortable="_.get(col, 'sort', false)"
            v-bind="{ ...col, type: _.get(col, 'columnType', '') }">
            <template v-slot:header>
                <div style="display: flex; align-items: center; flex: 1;">
                    <span class="must-fill-flag" v-if="col.mustFill">*</span>
                    <slot name="col-header" v-bind="{ col }" v-if="!!$scopedSlots['col-header']"></slot>
                    <span v-else style="flex: 1;">{{ $translate(col.label) }}</span>
                    <el-popover
                        v-if="['respScore', 'customerManage'].includes(tableID) && col.filterType"
                        trigger="click"
                        placement="bottom"
                        width="200">
                        <template v-slot:reference>
                            <i class="iconfont icon-search_senior" style="font-size: 10px; cursor: pointer;"></i>
                        </template>
                        <!-- 筛选选项 -->
                        <div class="filter-content">
                            <div class="filter-box">
                                <el-input v-if="col.filterType === 'input'" v-model.trim="col.filterModel" :placeholder="$translate('请输入' + col.label)" @keyup.enter.native="confirmFilter(col)">
                                </el-input>
                                <lots-select v-else-if="col.filterType === 'select'"
                                    class="search-select"
                                    :optionsKey="col.optionsKey"
                                    :options="col.options"
                                    collapse-tags
                                    filterable
                                    :placeholder="$translate('请选择' + col.label)"
                                    :multiple="_.get(col, 'multiple', true)"
                                    v-model="col.filterModel"
                                    @change="(val) => $emit('element-change', col)"
                                    clearable style="width: 100%" />
                                <el-cascader v-else-if="col.filterType === 'cascader'"
                                    class="cascader-search"
                                    size="mini"
                                    :key="col.filterOptions.length"
                                    v-model="col.filterModel"
                                    :options="col.filterOptions"
                                    :props="_.get(col, 'props', '')"
                                    :collapse-tags="_.get(col, 'collapseTags', true)"
                                    :show-all-levels="_.get(col, 'showAllLevels', false)"
                                    :clearable="_.get(col, 'clearable', true)"
                                    :filterable="_.get(col, 'filterable', true)"
                                    :disabled="_.get(col, 'disabled', false)"
                                    :placeholder="$translate('请选择' + col.label)"
                                    @change="(val) => $emit('element-change', col)"
                                />
                                <!-- <el-date-picker v-else-if="col.filterType === 'timeRange'"
                                    class='text-box'
                                    v-model="col.filterModel"
                                    :clearable="_.get(col, 'clearable', true)"
                                    size="mini"
                                    :format="_.get(col, 'format', 'yyyy-MM-dd HH:mm:ss')"
                                    :type="col.time?'daterange':'datetimerange'"
                                    unlink-panels
                                    range-separator="至"
                                    :start-placeholder="col.startPlaceholder ? $translate(col.startPlaceholder) : $translate('component.E202007300015', { defaultText: '开始日期' })"
                                    :end-placeholder="col.endPlaceholder ? $translate(col.endPlaceholder) : $translate('component.E202007300016', { defaultText: '结束日期' })"
                                    :default-time="['00:00:00', '23:59:59']"
                                    @change="elementChange(col)">
                                </el-date-picker> -->
                            </div>
                            <div class="filter-actions">
                                <el-button class="gray-btn" size="mini" @click="resetFilter(cIndex, col)">{{$translate('component.E202006240011', { defaultText: '重 置' })}}</el-button>
                                <lots-button type="primary" size="mini" @click="confirmFilter(col)">{{$translate('component.E202006240012', { defaultText: '搜 索' })}}</lots-button>
                            </div>
                        </div>
                    </el-popover>
                </div>
            </template>
            <!-- 专为嵌套表格使用 -->
            <slot name="nest-table" v-bind="{ col }"></slot>
            <template v-slot="{ row, $index: rIndex }">
                <template v-if="!col.type">{{ row[col.prop] }}</template>
                <template v-else-if="col.type === 'select'">{{ dictFormat(row[col.prop], col.optionsKey) |
                    keyMapFormat(col.options) }}</template>
                <slot v-else name="col-append" v-bind="{ col, row, rIndex }"></slot>
            </template>
        </el-table-column>
        <!-- </template> -->
        <el-table-column :label="$translate('lang.E202006152352', { defaultText: '操作' })" fixed="right"
            :width="actionColWidth" v-if="actionColShow">
            <template v-slot="{ row, $index: rIndex }">
                <template v-for="(e, eIndex) in actions.list">
                    <el-button v-if="e.displayRule(row)" type="text" size="mini" :key="eIndex"
                        @click="actionClick(e.event, row, rIndex)" :loading="row[e.event + 'loading'] || false">{{
                            $translate(e.label) }}</el-button>
                </template>
            </template>
        </el-table-column>
    </el-table>
</template>
<script>
import _ from 'lodash';
import { I18nMixins } from '@/components/mixins/i18n';
import { dictWithUrl } from '../api';
import lotsButton from '@/components/lots/lotsButton';
import lotsSelect from '@/components/lots/lotsSelect/Index';
const HEIGHTOFFSET = 210;
export default {
    name: 'tableBox',
    mixins: [I18nMixins],
    inheritAttrs: false,
    components: { lotsButton, lotsSelect },
    props: {
        actions: {
            type: Object,
            default() {
                return {
                    list: []
                };
            },
            validator: function (obj) {
                return !!obj.list;
            }
        },
        columns: {
            type: Array,
            required: true,
            default() {
                return [];
            }
        },
        rows: {
            type: Array,
            required: true,
            default() {
                return [];
            }
        },
        selection: {
            type: Boolean,
            default() {
                return false;
            }
        },
        selectable: {
            type: Function,
            default() {
                return true;
            }
        },
        index: {
            type: Boolean,
            default() {
                return false;
            }
        },
        version: {
            type: String,
            default() {
                return '';
            }
        },
        tableID: {
            type: String
        }
    },
    watch: {
        actions: {
            handler(val) {
                if (val.list) {
                    _.forEach(val.list, ele => {
                        if (!_.isFunction(ele.displayRule)) {
                            ele.displayRule = () => true;
                        }
                    });
                }
            },
            immediate: true
        },
        rows: {
            handler(val) {
                // fix 修正elementui多个tab都包含表格，切换tab时table复选框绝对定位计算错误的问题
                this.$refs.elTable.debouncedUpdateLayout();
                this.newRows = val;
            },
            immediate: false
        },
        activeColumns: {
            handler() {
                // 对newRows进行延迟赋值是为了修正列变化时右fix的操作列top属性计算异常的问题
                if (this.rows.length > 0) {
                    this.newRows = [];
                }
                this.$nextTick(() => {
                    this.newRows = this.rows;
                    this.$refs.elTable.debouncedUpdateLayout();
                });
            },
            immediate: false
        }
    },
    computed: {
        _() {
            return _;
        },
        attrsExt() {
            const result = _.cloneDeep(this.$attrs);
            if (!_.has(result, 'max-height') && !_.has(result, 'height')) {
                result.height = document.body.clientHeight - HEIGHTOFFSET;
            }
            return result;
        },
        actionColShow() {
            return this.actions.list && this.actions.list.length > 0;
        },
        actionColWidth() {
            const btnWidth = 50;
            return this.actions.fixedWidth || btnWidth * this.actions.list.length;
        },
        activeColumns() {
            return this.columns.filter(item => !item.hiddenColumn);
        },
        // 筛选后的数据
        filteredTableData() {
            return this.newRows.filter(item => {
                // 姓名筛选：如果有选中值，则只保留匹配项
                const namePass = this.nameFilter.length === 0 ? true : this.nameFilter.includes(item.name);
                // 性别筛选：如果有选中值，则只保留匹配项
                const genderPass = this.genderFilter.length === 0 ? true : this.genderFilter.includes(item.gender);
                // 所有筛选条件都满足才保留
                return namePass && genderPass;
            });
        }
    },
    filters: {
        keyMapFormat(val, options) {
            if (!options) return val;
            // 方案1的处理方式：options保持elementui格式
            // const obj = _.find(options, ['value', val]);
            // return _.get(obj, 'label', val);

            // 方案2的处理方式：options使用简单对象
            return _.get(options, val, val);
        }
    },
    data() {
        return {
            dictFormat: (val) => val,
            newRows: [],
            nameFilter: []
        };
    },
    methods: {
        actionClick(event, row, rIndex) {
            this.$emit('action-click', event, row, rIndex);
        },
        getTable() {
            return this.$refs['elTable'];
        },
        rowClassHandler({ row }) {
            return this.getTable().selection.includes(row) ? 'selected-row' : '';
        },
        // 确认筛选（关闭弹窗）
        confirmFilter(col) {
            const obj = {};
            obj[col.prop] = col.filterModel;
            this.$emit('col-filter', obj);
            // 手动关闭popover
            // this.$refs[`${type}Popover`]?.doClose();
        },
        // 重置筛选条件
        resetFilter(index, col) {
            this.activeColumns[index].filterModel = '';
            const obj = {};
            obj[col.prop] = '';
            this.$emit('col-filter', obj, col);
        }
    },
    created() {
        // 表格渲染前先判断表格列中使用到的数据字典是否都在浏览器端有备份，没有的进行接口获取，保证表格的字典转义
        const keys = _.chain(this.columns).map(obj => obj.optionsKey).filter(str => !_.isNil(str)).value();
        if (keys.length > 0) {
            dictWithUrl(keys.join(',')).then(obj => {
                if (obj.code === '0') {
                    const data = obj.data;
                    this.dictFormat = (val, optionsKey) => {
                        if (!optionsKey) return val;
                        const keyMaps = _.get(data, optionsKey);
                        return _.get(keyMaps, val, val);
                    };
                }
            });
        }
    }
};

</script>
<style lang="less">
.table-box {

    .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
        width: 100%;
    }

    .el-table__header {
        thead {
            .cell {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                display: flex;
            }
        }
    }

    .must-fill-flag {
        // font-size: 14px;
        color: #f25555;
        margin-right: 2px;
    }

    .el-table__fixed,
    .el-table__fixed-right {
        pointer-events: none;
        .el-table__fixed-header-wrapper {
            pointer-events: auto;
        }
        td {
            pointer-events: auto;
        }
    }

    .el-table__fixed .el-table__fixed-header-wrapper thead tr th:first-child .cell .el-checkbox {
        pointer-events: auto;
    }

}

.el-icon-filter {
  margin-left: 5px;
  cursor: pointer;
  color: #909399;
}

.el-icon-filter.active {
  color: #409eff; /* 筛选激活状态颜色 */
}

.filter-content {
  padding: 5px;
}

.filter-actions {
  margin-top: 15px;
  display: flex;
  justify-content: flex-end;
  gap: 5px;
  .gray-btn {
        background: #f5f5f5;
        color: #666;
        border-color: #f5f5f5;
        &:hover {
            color: #4285f5;
        }
    }
}
.cascader-search{
    width: 100%;
    height: 28px;
    .el-input .el-input__inner{
        height: 28px!important;
    }
    .el-cascader__search-input{
        margin: 2px 0 2px 7px;
    }
    .el-cascader__tags{
        height: 28px;
    }

}
.search-select {
    width: 100%;
    height: 28px;
    .el-input,
    .el-input input {
        height: 28px !important;
    }
    .el-input__icon {
        line-height: 28px !important;
    }
}
.text-box {
    position: relative;
    font-size: 12px;
    width: 100%;
}
</style>
